module.exports = __webpack_public_path__ + "img/img-avatar01.bb572955.jpg";